import { FunctionComponent } from 'preact';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { TagsplitOffer } from '~src/domains/common/assets/svg';
import { localeSelector } from '~src/domains/common/state/commonSelectors';
import * as styles from '~src/styles/domains/accept/components/SplitOfferSelectedTag.module.scss';

const SplitOfferSelectedTag: FunctionComponent = () => {
  const { t } = useTranslation();
  const locale = useSelector(localeSelector);
  const [language] = locale.split('-');
  return (
    <div
      className={`${styles['split-offer-selected-tag']} ${styles[language]}`}
    >
      <span className={styles['tag-text']}>
        {t('accept:splitOfferSelector.selectedOffer.selectedOffer')}
      </span>
      <TagsplitOffer />
    </div>
  );
};

export default SplitOfferSelectedTag;
